import axios from "@/hooks/axios/axios";
import type { IServiceStatusResponse } from "../types/types";

export const getServiceStatus = async (): Promise<IServiceStatusResponse> => {
  const { data } = await axios.get("/auth/admin/system/status");
  return data;
};
